import React from 'react'
import GenericGoBackBtn from '../GenericGoBackBtn/GenericGoBackBtn'
import styles from './PageLayout.module.scss'

interface PageLayoutProps {
  /** Titre de la page */
  title?: string
  /** Contenu de la page */
  children: React.ReactNode
  /** Afficher le bouton de retour */
  showBackButton?: boolean
  /** Lien de retour si pas d'historique */
  backButtonLinkToIfNoHistory?: string
  /** Label du bouton de retour */
  backButtonLabel?: string
  /** Lien de retour direct */
  backButtonTo?: string
  /** Le lien de retour direct remplace l'entrée courante de l'historique */
  backButtonReplace?: boolean
  /** Largeur maximale du conteneur (défaut: 800px) */
  maxWidth?: string | number
  /** Classes CSS supplémentaires */
  className?: string
  /** Classes CSS supplémentaires pour le titre */
  titleClassName?: string
}

/**
 * Composant Layout réutilisable pour les pages de l'application
 * 
 * @example
 * <PageLayout title="Ma page" showBackButton backButtonLinkToIfNoHistory="/home">
 *   <div>Contenu de la page</div>
 * </PageLayout>
 */
const PageLayout: React.FC<PageLayoutProps> = ({
  title,
  children,
  showBackButton = false,
  backButtonLinkToIfNoHistory,
  backButtonLabel = 'Retourner',
  backButtonTo,
  backButtonReplace = false,
  maxWidth = '800px',
  className = '',
  titleClassName = ''
}) => {
  const containerStyle: React.CSSProperties = {
    maxWidth: typeof maxWidth === 'number' ? `${maxWidth}px` : maxWidth,
    marginLeft: 'auto',
    marginRight: 'auto',
    width: '100%'
  }

  return (
    <div 
      className={`${styles.page} ${className}`.trim()}
      style={containerStyle}
    >
      {showBackButton && (
        <GenericGoBackBtn 
          linkToIfNoHistory={backButtonLinkToIfNoHistory}
          label={backButtonLabel}
          to={backButtonTo}
          replace={backButtonReplace}
        />
      )}
      
      {title && (
        <h1 className={`${styles.page__title} ${titleClassName}`.trim()}>
          {title}
        </h1>
      )}
      
      <div className={styles.page__content}>
        {children}
      </div>
    </div>
  )
}

export default PageLayout

